export default __webpack_public_path__ + "static/media/alertt.40c10967.svg";